import Vue from 'vue';

export const toastState = Vue.observable({
  visible: false,
  message: '',
  type: 'success',
  timer: null
});

export function showToast(message, type = 'success', duration = 2200) {
  if (toastState.timer) {
    clearTimeout(toastState.timer);
  }
  toastState.message = message;
  toastState.type = type;
  toastState.visible = true;
  toastState.timer = setTimeout(() => {
    toastState.visible = false;
    toastState.timer = null;
  }, duration);
}

export function hideToast() {
  if (toastState.timer) {
    clearTimeout(toastState.timer);
  }
  toastState.visible = false;
  toastState.timer = null;
}

if (typeof window !== 'undefined') {
  window.aihelpToast = showToast;
}
